<template>
  <b-container>
    <b-row class="justify-content-between align-items-center">
      <div class="header">
        <span>
          {{ label[name] }}
        </span>
        <span class="mr-3 d-inline-block d-xl-none">
          <img
            :src="InfoCircle"
            width="16"
            height="16"
            :id="`popover-target-${name}`"
          />
        </span>
        <b-popover
          :target="`popover-target-${name}`"
          triggers="hover"
          placement="right"
        >
          <template #title>Informations cadre</template>
          <!-- <p>Model : {{ model }}</p> -->
          <p>Capacité : {{ capacity }} m3</p>
          <p>Max H2 >= {{ maxH2 == 0 ? '0' : maxH2 > 0 ? Math.abs(maxH2).toFixed(1) : 'N/A' }}</p>
          <p>Type d'emballage : {{ packaging }}</p>
          <!-- <p>Taille : {{ size }}</p> -->
        </b-popover>
        <b-badge class="px-3" :class="{ active: status, disabled: !status }">
          {{ statusString }}
        </b-badge>
      </div>
      <!-- <div
        class="header text-uppercase text-center d-none d-md-block d-lg-none"
      >
        {{ model }}
      </div> -->
      <b-row class="align-items-center d-block d-xl-none">
        Ref :
        <b-dropdown
          :text="selectedFrameRef"
          :disabled="!isMaintainer"
          size="sm"
          class="mr-3"
          right
        >
          <b-dropdown-item
            v-for="item in frameReference"
            :key="item.id"
            @click="handleUpdateFrameReference(item)"
          >
            {{ item.name }}
          </b-dropdown-item>
        </b-dropdown>
      </b-row>
    </b-row>
    <b-row class="justify-content-around flex-nowrap">
      <b-col cols="3" xl="4" class="blue-card py-2 shadow-sm">
        {{ measures.temperature }}&deg;C
      </b-col>
      <b-col cols="3" xl="4" class="blue-card py-2 shadow-sm">
        {{ Math.abs(measures.pression).toFixed(2) }} bar
      </b-col>
      <b-col cols="3" xl="4" class="blue-card py-2 shadow-sm">
        {{
          measures.debit === 'N/A'
            ? measures.debit
            : Math.abs(measures.debit).toFixed(2) + 'kg'
        }}
      </b-col>
      <b-col cols="3" class="blue-card py-2 shadow-sm d-block d-xl-none">
        {{ level === 'N/A' ? level : Math.abs(level).toFixed(2) + '%' }}
      </b-col>
    </b-row>
    <b-row v-if="timestamp">
      <b-col cols="12" class="px-0 pt-1">
        <span class="float-right footer">
          Dernière mise à jour le {{ dateString }} à {{ timeString }}
        </span>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import InfoCircle from '@/assets/info-circle.svg';
import { mapGetters } from 'vuex';
export default {
  name: 'InfoVoie',
  computed: {
    ...mapGetters('auth', ['isMaintainer']),
    statusString() {
      return this.status ? 'Active' : 'Inactive';
    },
    dateString() {
      let day = new Date(this.timestamp).getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      let month = new Date(this.timestamp).getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      const year = new Date(this.timestamp).getFullYear();

      return `${day}/${month}/${year}`;
    },
    timeString() {
      let hours = new Date(this.timestamp).getHours();
      if (hours < 10) {
        hours = `0${hours}`;
      }
      let minutes = new Date(this.timestamp).getMinutes();
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }

      return `${hours}h${minutes}`;
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    status: {
      type: Boolean,
      required: true
    },
    measures: {
      type: Object,
      required: true
    },
    timestamp: {
      type: Number,
      required: false
    },
    active: {
      type: Boolean,
      default: false
    },
    model: {
      type: String,
      required: true
    },
    maxH2: {
      type: Number,
      required: false
    },
    packaging: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: true
    },
    capacity: {
      type: Number,
      required: false
    },
    level: {
      type: [Number, String],
      required: false
    },
    selectedFrameRef: {
      type: String,
      required: true
    },
    frameReference: {
      type: Array,
      required: true
    },
    updateFrameReference: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      label: {
        channel1: 'Voie 1',
        channel2: 'Voie 2',
        channel3: 'Voie 3',
        channel4: 'Voie 4'
      },
      InfoCircle
    };
  },
  methods: {
    handleUpdateFrameReference(item) {
      this.$emit('update-frame-reference', this.name, item);
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  text-align: left;
  font-weight: bold;
  margin: 5px;
}

.footer {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: grey;
}

.flex-gap {
  display: inline-flex;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: space-between;
}

.blue-card {
  background-color: $byes-blue;
  color: white;
  font-weight: bold;
  font-size: 1.5rem;
  white-space: nowrap;
  margin: 0.1rem;
  padding: 0.1rem;
}

@media (max-width: 767.98px) {
  .blue-card {
    font-size: 0.8rem;
  }
}

.active {
  background-color: $byes-green;
}

.disabled {
  background-color: $byes-grey;
}
</style>
